/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface All
 */
export interface All {
    /**
     * 
     * @type {string}
     * @memberof All
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof All
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof All
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof All
     */
    description?: string;
    /**
     * 
     * @type {any}
     * @memberof All
     */
    includeControls?: any | null;
    /**
     * 
     * @type {string}
     * @memberof All
     */
    href?: string;
}

/**
 * Check if a given object implements the All interface.
 */
export function instanceOfAll(value: object): value is All {
    return true;
}

export function AllFromJSON(json: any): All {
    return AllFromJSONTyped(json, false);
}

export function AllFromJSONTyped(json: any, ignoreDiscriminator: boolean): All {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'includeControls': json['includeControls'] == null ? undefined : json['includeControls'],
        'href': json['href'] == null ? undefined : json['href'],
    };
}

export function AllToJSON(json: any): All {
    return AllToJSONTyped(json, false);
}

export function AllToJSONTyped(value?: All | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'uuid': value['uuid'],
        'description': value['description'],
        'includeControls': value['includeControls'],
        'href': value['href'],
    };
}

